export enum WatermarkMode {
  /** 全局模式 */
  global = 1,
  /** 软件模式 */
  software = 2,
}
